var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGaugeArcYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 73.8631,
    height: 27.8959,
    viewBox: "0 0 73.8631 27.8959",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 527",
    d: "M72.524 24.3934C74.9453 20.8126 74.0184 15.9187 70.2663 13.7724C50.9212 2.7059 28.5298 -1.87695 6.3924 0.699292C2.09877 1.19896 -0.676369 5.33512 0.143463 9.57927V9.57927C0.963295 13.8234 5.06889 16.5627 9.36876 16.12C27.4148 14.2617 45.6059 17.9849 61.4708 26.7837C65.2509 28.8802 70.1026 27.9741 72.524 24.3934V24.3934Z",
    fill: "#F4D064"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaugeArcYellow);
export default __webpack_public_path__ + "static/media/gauge-arc-yellow.40064c9b93fc47eccc173bc08078e812.svg";
export { ForwardRef as ReactComponent };